import { WarningOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Modal, Typography, Button } from 'antd';

import type { FC } from 'react';

import '@app/components/Modals/AddWhatsAppIntegrationWarningModal/styles/AddWhatsAppIntegrationWarningModal.scss';

const { Paragraph } = Typography;

export interface Props {
  open: boolean;
  onCancel: () => void;
  onContinue: () => void;
  width?: number;
}

const PF = 'add-whatsapp-integration-warning-modal';

export const AddWhatsAppIntegrationWarningModal: FC<Props> = ({
  open,
  onCancel,
  onContinue,
  width = 720,
}) => (
  <Modal
    className={PF}
    open={open}
    width={width}
    maskClosable={false}
    destroyOnHidden
    centered
    title={
      <div className={`${PF}__title`} role="alert" aria-live="assertive">
        <WarningOutlined className={`${PF}__icon`} />
        <span>Внимание!</span>
      </div>
    }
    footer={
      <div className={`${PF}__footer`}>
        <div className={`${PF}__footer-actions`}>
          <Button onClick={onCancel}>Отмена</Button>
          <Button type="primary" onClick={onContinue}>
            Продолжить
          </Button>
        </div>
      </div>
    }
    onCancel={onCancel}
  >
    <div className={`${PF}__content`}>
      <Paragraph className={`${PF}__intro`}>
        Перед подключением канала WhatsApp убедитесь, что выполнены следующие
        условия:
      </Paragraph>

      <ol className={`${PF}__list ${PF}__list--numbered`}>
        <li>
          Аккаунт WhatsApp должен быть подключен к мобильному устройству{' '}
          <b>7 дней и дольше</b>.
        </li>
        <li>
          На данном аккаунте должно быть{' '}
          <b>не менее 15 состоявшихся диалогов</b>.
        </li>
        <li>
          С момента последней активной рассылки должно пройти{' '}
          <b>не менее 3 дней</b>.
        </li>
        <li>
          С момента последней блокировки (если таковая была) должно пройти{' '}
          <b>не менее 3 дней</b>.
        </li>
      </ol>

      <Paragraph className={`${PF}__section-title`}>
        Внимание! Для снижения вероятности блокировки:
      </Paragraph>

      <ul className={`${PF}__list ${PF}__list--danger`}>
        <li>
          <CloseCircleOutlined className={`${PF}__list-item-icon`} />
          Не отправляйте сообщения “холодным” клиентам — не ждущим вашего
          сообщения и не осведомлённым о вашем продукте.
        </li>
        <li>
          <CloseCircleOutlined className={`${PF}__list-item-icon`} />
          Не делайте рассылки с новых номеров, подключённых к WhatsApp{' '}
          <b>менее 2 месяцев</b>.
        </li>
      </ul>

      <Paragraph className={`${PF}__disclaimer`}>
        Мы не несём ответственности в случае блокировки вашего WhatsApp.
      </Paragraph>

      <Paragraph className={`${PF}__support`}>
        Для получения подробной консультации вы можете связаться с нашей службой
        поддержки по телефону или в WhatsApp: <b>8-980-210-00-10</b>
      </Paragraph>
    </div>
  </Modal>
);
